const baseStyle = {};
const defaultProps = {
    size: 'md'
};
const sizes = {
    xs: {
        fontSize: 'xs',
        lineHeight: '18px'
    },
    sm: {
        fontSize: 'sm',
        lineHeight: '22px'
    },
    md: {
        fontSize: 'md',
        lineHeight: '26px'
    },
    lg: {
        fontSize: 'lg',
        lineHeight: '32px'
    }
};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
